/**
 * Trigger: tr_expenses_delete
 * Purpose: Update account balances and clean up daily balances when an expense is hard deleted
 * Table: expenses
 * Event: BEFORE DELETE
 */
export const TR_EXPENSES_DELETE = `
CREATE TRIGGER tr_expenses_delete
BEFORE DELETE ON expenses
FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET expenses_amount = expenses_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET expenses_amount = expenses_amount - old.amount
  WHERE old.is_deleted = 0
    AND account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.expense_date;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND NOT EXISTS (
    SELECT _id FROM account_daily_balances
    WHERE account_daily_balances.account_id = account_activity_dates.account_id
      AND account_daily_balances.balance_date = account_activity_dates.activity_date
  );
END;
`;
